// Modules
import { Select, Button } from "antd";

// Components
import getIcon from "utils/getIcon";

// Styles
import styles from "components/organisms/NewUser/userRolesGroup.module.css";

// Constants
import { NewUser as Constants, ViewMode } from "constants/global";

// Types
import { GroupDetails } from "services/api/types";

const { Option } = Select;

type UserRolesGroupProps = {
	selectedGroups: Array<string>;
	currentSelectedGroup: { id: string; value: string };
	mode?: string;
	groupsList?: Array<GroupDetails>;
	setCurrentSelectedGroup: (value: string, option: any) => void;
	handleRemoveSelectedGroup: (value: string) => void;
	handleAddAnotherRole: () => void;
};

const UserRolesGroup = ({
	mode,
	groupsList,
	selectedGroups,
	currentSelectedGroup,
	setCurrentSelectedGroup,
	handleRemoveSelectedGroup,
	handleAddAnotherRole
}: UserRolesGroupProps) => {
	const filteredRolesList = selectedGroups?.length > 0 ? groupsList?.filter(({ group_code }) => !selectedGroups.includes(group_code)) : groupsList;

	return (
		<>
			{mode !== ViewMode.READ && (
				<div className={styles?.search_wrapper}>
					<Select
						disabled={mode === ViewMode.READ}
						className={styles?.search_input}
						bordered={false}
						suffixIcon={<span className="cursor-pointer">{getIcon({ icon: "search" })}</span>}
						showSearch
						style={{ width: 200 }}
						placeholder={<span>{"Search"}</span>}
						optionFilterProp="children"
						onChange={setCurrentSelectedGroup}
						value={currentSelectedGroup.value || null}
						filterOption={(input, option) => (option?.children as unknown as string)?.toLowerCase().includes(input?.toLowerCase())}
						// filterSort={(optionA, optionB) => (optionA!.children as unknown as string).toLowerCase().localeCompare((optionB!.children as unknown as string).toLowerCase())}
					>
						{filteredRolesList?.map((role, idx) => {
							return (
								<Option value={role?.group_code} id={role?.group_code} key={`${role?.group_id}-${idx}`}>
									{role?.group_code}
								</Option>
							);
						})}
					</Select>
					<Button icon={<span className="mr-2">{getIcon({ icon: "addIcon" })}</span>} className={styles?.add_another_button} type="link" onClick={handleAddAnotherRole}>
						{Constants.ADD_ANOTHER_GROUP_LABEL}
					</Button>
				</div>
			)}
			<div className={styles?.selected_groups_wrapper}>
				{selectedGroups?.map((group: string, idx: number) => {
					return (
						<Button
							key={`${group}-${idx}`}
							className={styles?.group_item}
							onClick={() => {
								if (mode !== ViewMode.READ) {
									handleRemoveSelectedGroup(group);
								}
							}}
							icon={<span className={styles?.group_item_icon}>{getIcon({ icon: "remove" })}</span>}
						>
							{group}
						</Button>
					);
				})}
			</div>
		</>
	);
};

export default UserRolesGroup;
